import { render, staticRenderFns } from "./ShProductBoxEA.vue?vue&type=template&id=1f0b9824&scoped=true&"
import script from "./ShProductBoxEA.vue?vue&type=script&lang=js&"
export * from "./ShProductBoxEA.vue?vue&type=script&lang=js&"
import style0 from "./ShProductBoxEA.vue?vue&type=style&index=0&id=1f0b9824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b9824",
  null
  
)

export default component.exports